// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"170":"212d1493","365":"016bbdd5","488":"ef8688e9"}[chunkId] + ".chunk.js";
};